import react, { useState, useEffect } from "react";
import SuggestArchetype from "./SuggestArchetype";

const API_URL = process.env.REACT_APP_API_URL || "https://the-boggler-api-96bc2fa97f2d.herokuapp.com/api";

const SelectGuideTypesModal = (props) => {
    const [potentialGuideTypes, setPotentialGuideTypes] = useState([]);
    const [filteredGuideTypes, setFilteredGuideTypes] = useState([]);
    const [showSelectGuideTypes, setShowSelectGuideTypes] = useState(true);
    const [showAddCustomArchetypes, setShowAddCustomArchetypes] = useState(false);
    const [suggestedArchetypes, setSuggestedArchetypes] = useState(props?.suggestedArchetypes || []);

    const searchGuideTypes = (searchTerm) => {
        const filtered = potentialGuideTypes.filter((guideType) =>
            guideType.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredGuideTypes(filtered);
    };

    const handleSelectGuideType = (hyphenated_title) => {
        if(props.selectedGuideTypes.includes(hyphenated_title)) {
            props.removeGuideType(hyphenated_title);
            return;
        } else {
            props.addGuideType(hyphenated_title);
        }
    }

    const getPotentialGuideTypes = async () => {
        const response = await fetch(`${API_URL}/guide/guide-types`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        if(data && data.guideTypes) {
            const currentGuideTypes = props?.currentGuideTypes || [];
            let theKnownGuideTypes = data.guideTypes || [];
            if(currentGuideTypes.length > 0) {
                currentGuideTypes.filter((type) => {
                    const exists = theKnownGuideTypes.find((gt) => gt.hyphenated_title === type);
                    if(!exists) {
                        theKnownGuideTypes.push({
                            hyphenated_title: type,
                            title: type.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
                        });
                    }
                });
            }
            setPotentialGuideTypes(theKnownGuideTypes);
            setFilteredGuideTypes(theKnownGuideTypes);
        }
    };

    useEffect(() => {
        getPotentialGuideTypes();
    }, []);

    const modalRef = react.useRef(null);

    const handleClose = () => {
        if(showAddCustomArchetypes) {
            props?.setShow(true);
            setShowAddCustomArchetypes(false);
            setShowSelectGuideTypes(true);
            searchGuideTypes("");
            props.setShowAddCustomArchetypeModal(false);
        } else {
            modalRef.current?.dismiss();
            setShowAddCustomArchetypes(false);
            setShowSelectGuideTypes(false);
            props.setShowAddCustomArchetypeModal(false);
            searchGuideTypes("");
        }
    }
    const handleClickShowAddCustomArchetypes = () => {
        props.setShowAddCustomArchetypeModal(true);
        setShowAddCustomArchetypes(true); 
        setShowSelectGuideTypes(false);
    }

    const handleAddSuggestedArchetype = (archetype) => {
        setSuggestedArchetypes([...suggestedArchetypes, archetype]);
        setPotentialGuideTypes([...potentialGuideTypes, archetype]);
        setFilteredGuideTypes([...filteredGuideTypes, archetype]);
    }

    return (
        <div className='select-archetype-modal-container'>
            <div className="select-archetype-modal-overlay" onClick={() => props?.setShow(false)}></div>
                <div className="select-archetype-modal">
                    <div className="modal-header">
                    <span className="modal-close-button" onClick={() => {showAddCustomArchetypes ? handleClose() : props?.setShow(false);}}>❌</span>
                </div>
                <div className="select-archetype-modal-body">
                    <h2>{showAddCustomArchetypes ? "Add Custom Archetype" : "Select Guide Types"}</h2>
                    {showAddCustomArchetypes && <SuggestArchetype addSuggestedArchetype={handleAddSuggestedArchetype} suggestedArchetypes={suggestedArchetypes} dismiss={() => { setShowAddCustomArchetypes(false); setShowSelectGuideTypes(true); }} />}
                    {showSelectGuideTypes && (
                        <>
                            <button className="center-form-button add-custom-achetype-button" onClick={handleClickShowAddCustomArchetypes}>Add Custom Archetype</button>
                            <input type="text" placeholder="Search Guide Types..." style={{width: "auto", padding: "8px", margin: "5px auto"}} onChange={(e) => searchGuideTypes(e.target.value)} />
                            <ul style={{width: "100%", listStyleType: "none", padding: 0, maxHeight: "300px", overflowY: "auto"}}>
                                {filteredGuideTypes.map((guideType, index) => (
                                    <li className={"guide-type-item "+(props.selectedGuideTypes.includes(guideType.hyphenated_title) ? "selected" : "")} key={guideType+" "+index} style={{padding: "10px", borderBottom: "1px solid #ccc", cursor: "pointer"}} onClick={() => handleSelectGuideType(guideType.hyphenated_title)}>
                                        {guideType.title}
                                    </li>
                                ))}
                            </ul>
                            <button className="center-form-button" onClick={() => { showAddCustomArchetypes ? handleClose() : props.setShow(false); searchGuideTypes(""); }} style={{marginTop: "10px", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>
                                Done
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SelectGuideTypesModal;